export const LegalPapersTags = [
    { id: 'legals', name: 'Mentions légales' },
    { id: 'terms-of-use', name: 'Conditions d\'utilisation' },
    { id: 'privacy-policy', name: 'Politique de confidentialité' },
    { id: 'cookies', name: 'Politique de cookies' },
    { id: 'shipping-policy', name: 'Politique de livraison' },
    { id: 'payment-policy', name: 'Politique de paiement' },
    { id: 'refund-policy', name: 'Politique de remboursement' },
    { id: 'disclaimer', name: 'Avertissement de non-responsabilité' },
];